<template>
  <div class="modal fade" id="AddInfoRemiseModal" tabindex="-1" aria-labelledby="AddInfoRemiseModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-white border-bottom">
          <h5 class="text-black fw-bold mb-0">
            <i class="fa fa-percent me-2 text-primary"></i>Informations Remise & Taxe
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-4">
          <div class="row gx-3">
            <div class="col-5">
              <label class="d-block text-black fw-semibold mb-2">Type RSE</label>
              <select v-model="localTypeRemise" class="form-select">
                <option value="">Aucune</option>
                <option value="%">%</option>
                <option value="MT">MT</option>
              </select>
            </div>

            <div class="col-5">
              <label class="d-block text-black fw-semibold mb-2">Valeur Remise</label>
              <input 
                type="number" 
                v-model.number="localValeurRemise" 
                class="form-control" 
                placeholder="0" 
                min="0" />
            </div>

            <div class="col-2">
              <label class="d-block text-black fw-semibold mb-2">Taxe S.</label>
              <input 
                type="number" 
                v-model.number="localTaxeSpecifique" 
                class="form-control" 
                placeholder="0" 
                min="0" />
            </div>
          </div>
        </div>
        <div class="modal-footer bg-light">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            <i class="fa fa-times me-1"></i>Annuler
          </button>
          <button type="button" class="btn btn-primary" @click="valider" data-bs-dismiss="modal">
            <i class="fa fa-check me-1"></i>Valider
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import Multiselect from "@vueform/multiselect";

export default defineComponent({
  name: 'AddInfoRemiseModal',
  components: {
    Multiselect
  },
  props: {
    typeRemise: {
      type: String,
      default: ''
    },
    valeurRemise: {
      type: Number,
      default: 0
    },
    taxeSpecifique: {
      type: Number,
      default: 0
    }
  },
  emits: ['update'],
  setup(props, { emit }) {
    const localTypeRemise = ref(props.typeRemise);
    const localValeurRemise = ref(props.valeurRemise);
    const localTaxeSpecifique = ref(props.taxeSpecifique);

    watch(() => props.typeRemise, (newVal) => {
      localTypeRemise.value = newVal;
    });

    watch(() => props.valeurRemise, (newVal) => {
      localValeurRemise.value = newVal;
    });

    watch(() => props.taxeSpecifique, (newVal) => {
      localTaxeSpecifique.value = newVal;
    });

    const valider = () => {
      emit('update', {
        typeRemise: localTypeRemise.value,
        valeurRemise: localValeurRemise.value,
        taxeSpecifique: localTaxeSpecifique.value
      });
    };

    return {
      localTypeRemise,
      localValeurRemise,
      localTaxeSpecifique,
      valider
    };
  }
});
</script>

<style scoped>
.modal-header {
  background-color: #ffffff !important;
  border-bottom: 1px solid #dee2e6;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
}

.form-label {
  margin-bottom: 0.5rem;
  color: #000000;
  font-weight: 600;
}

.btn-primary:hover {
  background-color: #4d4189 !important;
  border-color: #4d4189 !important;
}
</style>
